"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOT_FOUND = exports.UNHANDLED = exports.INVALID_PARAMETER = exports.INVALID_ZIPCODE = exports.INVALID_PHONE_NUMBER = exports.INVALID_PASSWORD = exports.INVALID_NAME = exports.INVALID_EMAIL = exports.WORKER_EXISTS = exports.WORKER_CREATION_FAILED = exports.NOT_ATTORNEY = exports.ORG_USER_EXISTS = exports.ATTORNEY_EXISTS = exports.ATTORNEY_CREATION_FAILED = exports.UNAUTHORIZED_DISQUALIFIED_FILER = exports.FILER_EXISTS = exports.FILER_CREATION_FAILED = exports.NO_TOKEN = exports.UNAUTHORIZED = exports.NO_ACCOUNT = exports.BAD_PASSWORD = void 0; // Accounts
// - auth

exports.BAD_PASSWORD = "badPassword";
exports.NO_ACCOUNT = "noAccount";
exports.UNAUTHORIZED = "unauthorized";
exports.NO_TOKEN = "noToken"; // - filer

exports.FILER_CREATION_FAILED = "filerCreationFailed";
exports.FILER_EXISTS = "filerExists";
exports.UNAUTHORIZED_DISQUALIFIED_FILER = "unauthorizedDisqualifiedFiler"; // - attorney

exports.ATTORNEY_CREATION_FAILED = "attorneyCreationFailed";
exports.ATTORNEY_EXISTS = "attorneyExists";
exports.ORG_USER_EXISTS = "orgUserExists";
exports.NOT_ATTORNEY = "notAttorney"; // - worker

exports.WORKER_CREATION_FAILED = "workerCreationFailed";
exports.WORKER_EXISTS = "workerExists"; // Validation

exports.INVALID_EMAIL = "invalidEmail";
exports.INVALID_NAME = "invalidName";
exports.INVALID_PASSWORD = "invalidPassword";
exports.INVALID_PHONE_NUMBER = "invalidPhoneNumber";
exports.INVALID_ZIPCODE = "invalidZipcode"; // Parameters

exports.INVALID_PARAMETER = "invalidParameter"; // Misc

exports.UNHANDLED = "unhandled";
exports.NOT_FOUND = "notFound";